import React, { useState, useEffect } from "react";
// import logo from "../Images/Neoo search logo white.png";
// import logo from "../Images/Neoo white logo.svg";
import logo from "../Images/logo/white.png";
import prfl from "../../src/Images/prfl.png";
import TopSearch from "../Component/TopSearch";
import {
  Link,
  unstable_HistoryRouter,
  useNavigate,
  NavLink,
  useLocation,
} from "react-router-dom";
// import { navigate } from '@reach/router';
import HttpClient from "../utils/HttpClient";
import SearchBarmodal from "../Component/SearchBarmodal";
import { useDispatch, useSelector } from "react-redux";
import {
  ProfileSubmenuDropDown,
  SearchModal,
  ShareModalonOff,
  UserLogout,
  getOwnProfile,
} from "../Redux/Slice/PostSlice";
import { QrCamera } from "../View/QRCamera/QrCamera";
import toast from "react-hot-toast";
import reicon from "../Images/Reward.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import Sidebar from "../Component/Sidebar";
import NotificationBar from "../Component/NotificationBar";
import searchhomeprofileimg from "../../src/Images/searchhomeprofileimg.png";
import nophotoCamera from "../../src/Images/cameralogo.png";
import { fetchAllNotifications, readAllNotifications } from "../Redux/Slice/NotificationSlice";

const Header = () => {
  const [camera, setCamera] = useState(false);
  const [stickyheader, setStickyheader] = useState(false);
  const [hanndleglass, SetHandleglass] = useState(false);
  const [showmenu, setShowmenu] = useState(false);
  const [profilePic, setprofilePic] = useState({});
  const [homePageUrl, sethomePageUrl] = useState("");
  const [paramsUserMember, setparamsUserMember] = useState("");
  const [params, setparams] = useState("");
  const [userMemberStatus, setusermemberstatus] = useState("");
  const [partnerStatus, setpartnerStatus] = useState(""); //partner status for dynamically showing  partner button in header

  // usermember link copy  text
  const [userMemberUserLink, setuserMemberUserLink] = useState("");
  const [copiedStatus, setCopiedStatus] = useState(false);
  // usermember link copy  text end
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { SearchBar, ProfileSubmenuDropDownToggle, UserProfileID } =
    useSelector((state) => state.app);

  const { UnreadNotificationsCount } = useSelector((state) => state.notification);

  const location = useLocation();
  const currentPage = location.pathname;
  // console.log("DER58", AllNotifications);

  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0)

  // console.log(partnerStatus, "partnerStatus");
  // console.log(userMemberUserLink, "userMemberUserLink");
  // console.log(SearchBar, "SearchBar");
  // console.log("LINE52", UserProfileID);


  // handlesearch

  //sidebar menu start
  const sidebaropen = () => {
    document.querySelector(".sidebardiv").style.cssText += "right: 0";
  };
  //sidebar menu end

  //Copied status
  const handleCopyClick = () => {
    setCopiedStatus(true);
  };

  // const dispatch = useDispatch()


  const [showNotifibar, setshowNotifibar] = useState(false);

  const toggleNotifibar = () => {
    setshowNotifibar(!showNotifibar);
    //Call function to update read notification
    // dispatch(readAllNotifications())
  };

  useEffect(() => {
    // alert(1)
    showNotifibar && dispatch(fetchAllNotifications())
  }, [showNotifibar])



  const handleglassClick = (e) => {
    e.stopPropagation();
    dispatch(ProfileSubmenuDropDown(false));
    // navigate("/OwnContactlist");
    // SetHandleglass(!hanndleglass);
    // if (SearchBar) {
    //   dispatch(SearchModal(false));
    // } else {
    //   dispatch(SearchModal(true));
    // }
    dispatch(SearchModal(!SearchBar));
  };

  const handClick = (e) => {
    // if (!ProfileSubmenuDropDownToggle) {
    //   dispatch(ProfileSubmenuDropDown(true));
    // } else {
    //   dispatch(ProfileSubmenuDropDown(false));
    // }
    // setShowmenu(!showmenu);

    e.stopPropagation();
    dispatch(ProfileSubmenuDropDown(!ProfileSubmenuDropDownToggle));
  };

  function setFixed() {
    if (window.scrollY > 300) {
      setStickyheader(true);
    } else {
      setStickyheader(false);
    }
  }

  window.addEventListener("scroll", setFixed);
  // Logout
  const handleLogOut = () => {
    toast.success("Logout SuccessFull");
    dispatch(UserLogout())
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  const getUserProfile = async () => {
    const res = await HttpClient.requestData("get-profile", "GET", {});
    console.log(res?.data, "user%profile");
    if (res && res?.status) {
      setparams(res?.data?.personName?.replace(/ /g, "_"));
      setparamsUserMember(res?.data?.userName);
      setuserMemberUserLink(res?.data?.userLink);
      setprofilePic(res?.data);

      if (res?.data?.memberStatus) {
        setusermemberstatus(res?.data?.memberStatus);
        setpartnerStatus(res?.data?.partnerStatus);
        sethomePageUrl("/profile/");
      } else {
        setusermemberstatus(res?.data?.memberStatus);
        sethomePageUrl("/NonMemberuserprofile/");
      }
    }
  };
  const reloadPage = () => {
    navigate("/OwnContactlist");
    // window.location.reload();
  };
  useEffect(() => {
    getUserProfile();
  }, []);
  useEffect(() => {
    if (copiedStatus) {
      toast.success("Copied to clipboard");
    }
  }, [copiedStatus]);
  useEffect(() => {
    let timeoutId;
    if (copiedStatus) {
      timeoutId = setTimeout(() => {
        setCopiedStatus(false);
      }, 3000); // Reset copied status after 3 seconds
    }
    return () => clearTimeout(timeoutId);
  }, [copiedStatus]);

  // fetch own profile

  useEffect(() => {
    // dispatch(getOwnProfile());
  }, []);


  return (
    <>
      <section className={stickyheader ? "mainheader fixed" : "mainheader"}>
        <div className="TopHeader">
          <div className="cust_container">
            <div className="headerlogocnctmain">
              {userMemberStatus ? (
                <Link
                  // to={homePageUrl + paramsUserMember}
                  to="/"
                  onClick={() => {
                    dispatch(SearchModal(false));
                    dispatch(ProfileSubmenuDropDown(false));
                  }}
                >
                  <figure className="logoneeo">
                    <img src={logo} alt="..." />
                  </figure>
                </Link>
              ) : (
                <Link
                  // to={homePageUrl + params}
                  to="/"
                  onClick={() => {
                    dispatch(SearchModal(false));
                    dispatch(ProfileSubmenuDropDown(false));
                  }}
                >
                  <figure className="logoneeo">
                    <img src={logo} alt="..." />
                  </figure>
                </Link>
              )}
              <div className="iconmainheader">
                <div
                  className="iconhdmin"
                  onClick={handleglassClick}
                  id="headSerIcon"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path d="M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z" />
                  </svg>

                  <span className="headermenuname">Search</span>
                </div>

                <Link to="/OwnContactlist" onClick={() => reloadPage()}>
                  <div className="iconhdmin" id="headDirctryIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.0"
                      viewBox="0 0 40.000000 40.000000"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <g
                        transform="translate(0.000000,40.000000) scale(0.100000,-0.100000)"
                        stroke="none"
                      >
                        <path d="M155 370 c-35 -39 7 -99 61 -86 14 4 30 17 36 31 25 56 -54 102 -97 55z m75 -19 c7 -15 6 -23 -6 -35 -19 -20 -29 -20 -48 0 -20 19 -5 54 24 54 11 0 24 -9 30 -19z" />
                        <path d="M73 288 c-18 -19 -36 -48 -39 -66 -8 -37 11 -45 20 -8 3 14 18 38 32 55 36 44 25 59 -13 19z" />
                        <path d="M290 302 c0 -5 11 -19 24 -32 14 -12 28 -35 31 -51 8 -36 25 -48 25 -18 0 30 -47 109 -65 109 -8 0 -15 -4 -15 -8z" />
                        <path d="M15 130 c-39 -43 15 -107 70 -82 13 6 27 23 31 37 13 54 -62 88 -101 45z m73 -31 c4 -31 -19 -44 -49 -29 -22 12 -24 31 -7 48 21 21 53 10 56 -19z" />
                        <path d="M294 125 c-35 -53 27 -106 81 -71 30 20 33 56 7 79 -28 26 -69 21 -88 -8z m75 -9 c23 -28 -17 -68 -45 -45 -15 12 -19 41 -7 52 11 12 40 8 52 -7z" />
                        <path d="M124 29 c-12 -19 118 -27 146 -9 8 5 13 10 10 11 -22 5 -153 3 -156 -2z" />
                      </g>
                    </svg>
                    <span className="headermenuname">Directory</span>
                  </div>
                </Link>

                {UserProfileID?.memberStatus && (
                  <Link
                    to="/reward"
                    onClick={() => {
                      dispatch(SearchModal(false));
                      dispatch(ProfileSubmenuDropDown(false));
                    }}
                  >
                    <div className="iconhdmin" id="headRewardIcon">
                      {/* <i className="fa-solid fa-gift"></i> */}
                      {/* <img src={reicon} className="img-fluid" alt="..." /> */}
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        height="1em"
                        width="1em"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3.75 3.75c0 .844.279 1.623.75 2.25H2.75A1.75 1.75 0 001 7.75v2.5c0 .698.409 1.3 1 1.582v8.418c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0022 20.25v-8.418c.591-.281 1-.884 1-1.582v-2.5A1.75 1.75 0 0021.25 6H19.5a3.75 3.75 0 00-3-6c-1.456 0-3.436.901-4.5 3.11C10.936.901 8.955 0 7.5 0a3.75 3.75 0 00-3.75 3.75zM11.22 6c-.287-3.493-2.57-4.5-3.72-4.5a2.25 2.25 0 000 4.5h3.72zm9.28 6v8.25a.25.25 0 01-.25.25h-7.5V12h7.75zm-9.25 8.5V12H3.5v8.25c0 .138.112.25.25.25h7.5zm10-10a.25.25 0 00.25-.25v-2.5a.25.25 0 00-.25-.25h-8.5v3h8.5zm-18.5 0h8.5v-3h-8.5a.25.25 0 00-.25.25v2.5c0 .138.112.25.25.25zm16-6.75A2.25 2.25 0 0116.5 6h-3.72c.287-3.493 2.57-4.5 3.72-4.5a2.25 2.25 0 012.25 2.25z"
                        />
                      </svg>
                      <span className="headermenuname">Rewards</span>
                    </div>
                  </Link>
                )}

                <div
                  className="iconhdmin"
                  id="QRIcon"
                  onClick={() => setCamera(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path d="M0.0681529 14.4484C0.0681529 14.3802 0.0681529 14.3802 0.136306 14.3121C0.272611 13.835 0.681529 13.4942 1.1586 13.5624C1.63567 13.6305 2.04459 13.9713 2.04459 14.4484C2.04459 14.5165 2.04459 14.5165 2.04459 14.5847C2.04459 15.8114 2.04459 17.1063 2.04459 18.3331C2.04459 18.6739 2.18089 18.9465 2.38535 19.0828C2.52166 19.2191 2.72611 19.2872 2.93057 19.2872C2.99873 19.2872 3.06688 19.2872 3.06688 19.2872C4.29363 19.2872 5.52038 19.2872 6.74713 19.2872C6.88344 19.2872 7.01974 19.2872 7.15605 19.3554C7.56497 19.4917 7.83758 19.9006 7.76943 20.3095C7.76943 20.7184 7.42866 21.0592 7.01974 21.1955C6.95159 21.1955 6.95159 21.1955 6.88344 21.2637C5.52038 21.2637 4.15732 21.2637 2.79427 21.2637H2.72611C2.58981 21.2637 2.52166 21.2637 2.38535 21.1955C1.1586 20.9229 0.204459 19.9006 0.0681529 18.6739C0.0681529 18.6057 0.0681529 18.5376 0 18.5376C0.0681529 17.1745 0.0681529 15.8114 0.0681529 14.4484Z" />
                    <path d="M0.0683594 2.72611C0.0683594 2.72611 0.0683594 2.65796 0.136512 2.58981C0.272818 1.36306 1.22696 0.272611 2.45371 0.0681529C2.59002 0 2.79447 0 2.93078 0C4.22568 0 5.52059 0 6.88365 0C7.36072 0 7.76963 0.340764 7.83779 0.885987C7.90594 1.36306 7.56517 1.77197 7.0881 1.90828C7.01995 1.90828 6.88365 1.90828 6.81549 1.90828C5.58874 1.90828 4.36199 1.90828 3.06709 1.90828C2.99893 1.90828 2.86263 1.90828 2.79447 1.90828C2.3174 2.04459 2.04479 2.4535 2.04479 2.93057C2.04479 4.22548 2.04479 5.52038 2.04479 6.74713C2.04479 7.0879 1.90849 7.36051 1.70403 7.56497C1.15881 8.04204 0.340971 7.70127 0.136512 7.01974C0.136512 6.95159 0.136512 6.95159 0.0683594 6.88344C0.0683594 5.45223 0.0683594 4.08917 0.0683594 2.72611Z" />
                    <path d="M14.5168 21.3318C14.4487 21.3318 14.4487 21.3318 14.3805 21.2637C13.9035 21.1955 13.6309 20.7866 13.6309 20.3095C13.6309 19.9006 13.9716 19.4917 14.3805 19.4235C14.4487 19.4235 14.585 19.4235 14.6532 19.4235C15.8799 19.4235 17.1067 19.4235 18.4016 19.4235C18.5379 19.4235 18.6742 19.4235 18.8105 19.3554C19.2194 19.2191 19.4239 18.8783 19.4239 18.4694C19.4239 18.4012 19.4239 18.4012 19.4239 18.3331C19.4239 17.1063 19.4239 15.8114 19.4239 14.5847C19.4239 14.0394 19.8328 13.6305 20.3098 13.6305C20.8551 13.5624 21.264 13.9713 21.3321 14.3802C21.3321 14.4484 21.3321 14.5165 21.3321 14.5847C21.3321 15.8796 21.3321 17.1745 21.3321 18.4694C21.3321 19.4917 20.7188 20.7184 19.492 21.1955C19.2194 21.2637 18.9468 21.3318 18.6742 21.4H18.606C17.243 21.3318 15.8799 21.3318 14.5168 21.3318Z" />
                    <path d="M0.0683594 18.5371C0.0683594 18.6053 0.0683594 18.6734 0.136512 18.6734C0.272818 19.9002 1.22696 20.9225 2.45371 21.1951C2.59002 21.1951 2.65817 21.2632 2.79447 21.2632H2.86263C1.90849 21.2632 1.0225 21.2632 0.0683594 21.2632C0.0683594 20.3772 0.0683594 19.4912 0.0683594 18.5371Z" />
                    <path d="M17.5156 14.5165C17.5156 15.1299 17.5156 15.8114 17.5156 16.4248C17.5156 16.6974 17.4475 16.9019 17.243 17.1063C17.0386 17.3108 16.8341 17.4471 16.5615 17.4471H16.4934C15.1985 17.4471 13.9717 17.4471 12.6768 17.4471C12.5405 17.4471 12.4042 17.4471 12.2679 17.3789C11.9271 17.1745 11.7227 16.9019 11.7227 16.4929C11.7227 16.4248 11.7227 16.4248 11.7227 16.3566C11.7227 15.1299 11.7227 13.835 11.7227 12.6082C11.7227 12.063 12.1316 11.5859 12.6768 11.5859C13.3583 11.5859 14.108 11.5859 14.7895 11.5859C15.3348 11.5859 15.9481 11.5859 16.4934 11.5859C16.766 11.5859 17.0386 11.6541 17.243 11.9267C17.3793 12.063 17.4475 12.2675 17.5156 12.5401C17.5156 12.6082 17.5156 12.6764 17.5156 12.6764C17.5156 13.2898 17.5156 13.9031 17.5156 14.5165ZM14.5851 15.4707C14.7214 15.4707 14.9258 15.4707 15.0621 15.4707C15.3348 15.4707 15.5392 15.2662 15.5392 14.9936C15.5392 14.6528 15.5392 14.3121 15.5392 13.9713C15.5392 13.6987 15.3348 13.4942 15.0621 13.4942C14.7214 13.4942 14.3806 13.4942 14.108 13.4942C13.8354 13.4942 13.6309 13.6987 13.6309 13.9713C13.6309 14.3121 13.6309 14.6528 13.6309 14.9254C13.6309 15.2662 13.9035 15.4025 14.108 15.4025C14.3125 15.4707 14.4488 15.4707 14.5851 15.4707Z" />
                    <path d="M6.88293 3.88477C7.4963 3.88477 8.17783 3.88477 8.79121 3.88477C9.13197 3.88477 9.40458 4.02107 9.60904 4.36184C9.6772 4.49814 9.74535 4.63445 9.74535 4.77075C9.74535 4.83891 9.74535 4.83891 9.74535 4.90706C9.74535 6.20196 9.74535 7.42871 9.74535 8.72362C9.74535 8.99623 9.6772 9.20069 9.47274 9.40515C9.26828 9.60961 9.06382 9.74591 8.79121 9.74591H8.72305C7.4963 9.74591 6.2014 9.74591 4.97465 9.74591C4.83834 9.74591 4.70204 9.74591 4.56573 9.67776C4.22497 9.4733 4.02051 9.20069 4.02051 8.79177C4.02051 8.51916 4.02051 8.3147 4.02051 8.04209C4.02051 7.0198 4.02051 5.92935 4.02051 4.90706C4.02051 4.36184 4.42942 3.95292 4.97465 3.95292C5.58802 3.88477 6.2014 3.88477 6.88293 3.88477ZM6.88293 5.79305C6.74662 5.79305 6.54216 5.79305 6.40586 5.79305C6.13325 5.79305 5.92879 5.9975 5.92879 6.27012C5.92879 6.61088 5.92879 6.88349 5.92879 7.22426C5.92879 7.49687 6.13325 7.70133 6.40586 7.70133C6.74662 7.70133 7.01923 7.70133 7.36 7.70133C7.63261 7.70133 7.83707 7.49687 7.83707 7.22426C7.83707 6.88349 7.83707 6.61088 7.83707 6.27012C7.83707 5.9975 7.63261 5.79305 7.36 5.79305C7.15554 5.79305 7.01923 5.79305 6.88293 5.79305Z" />
                    <path d="M21.4005 4.7707C21.4005 5.45223 21.4005 6.13376 21.4005 6.81529C21.4005 7.15605 21.2642 7.36051 20.9915 7.56497C20.7189 7.76943 20.3782 7.83758 20.0374 7.70127C19.6966 7.56497 19.4922 7.29236 19.4922 6.88344C19.4922 6.81529 19.4922 6.74713 19.4922 6.67898C19.4922 5.45223 19.4922 4.22548 19.4922 2.99873C19.4922 2.79427 19.424 2.52166 19.2877 2.38535C19.0833 2.11274 18.8788 1.97643 18.538 1.97643C18.4699 1.97643 18.4017 1.97643 18.4017 1.97643C17.175 1.97643 15.9482 1.97643 14.7215 1.97643C14.4489 1.97643 14.2444 1.90828 14.04 1.70382C13.7673 1.43121 13.631 1.02229 13.7673 0.681529C13.8355 0.272611 14.1763 0 14.5852 0C15.9482 0 17.2431 0 18.6062 0C19.2196 0 19.8329 0.204459 20.31 0.613376C20.9234 1.09045 21.2642 1.77197 21.4005 2.58981C21.4005 2.72611 21.4005 2.86242 21.4005 2.93057C21.4005 3.54395 21.4005 4.15732 21.4005 4.7707Z" />
                    <path d="M17.5155 6.74719C17.5155 7.36056 17.5155 8.04209 17.5155 8.65547C17.5155 8.92808 17.4474 9.13254 17.2429 9.33699C16.9703 9.60961 16.6296 9.74591 16.2206 9.60961C15.8117 9.4733 15.6073 9.20069 15.5391 8.79177C15.5391 8.72362 15.5391 8.65547 15.5391 8.58731C15.5391 7.83763 15.5391 7.08795 15.5391 6.33827C15.5391 6.27012 15.5391 6.27012 15.5391 6.20196C15.5391 5.9975 15.3347 5.79305 15.062 5.79305C14.9939 5.79305 14.9939 5.79305 14.9257 5.79305C14.1761 5.79305 13.4264 5.79305 12.6085 5.79305C12.2678 5.79305 11.9952 5.65674 11.7907 5.38413C11.6544 5.11152 11.6544 4.77075 11.7907 4.42999C11.927 4.08922 12.2678 3.88477 12.6085 3.88477C12.813 3.88477 12.9493 3.88477 13.1538 3.88477C14.2442 3.88477 15.4028 3.88477 16.4933 3.88477C16.7659 3.88477 16.9703 3.95292 17.1748 4.08922C17.3792 4.29368 17.5155 4.49814 17.5155 4.77075C17.5155 4.83891 17.5155 4.90706 17.5155 4.97521C17.5155 5.52043 17.5155 6.13381 17.5155 6.74719Z" />
                    <path d="M7.63338 13.5628C7.22446 13.5628 6.81555 13.5628 6.40663 13.5628C6.13402 13.5628 5.86141 13.7672 5.86141 14.108C5.86141 14.2443 5.86141 14.3806 5.86141 14.5851C5.86141 15.1303 5.45249 15.5392 4.90727 15.5392C4.36204 15.5392 3.95312 15.1303 3.95312 14.5851C3.95312 13.9035 3.95312 13.2902 3.95312 12.6086C3.95312 12.1997 4.29389 11.7908 4.77096 11.7227C4.83911 11.7227 4.90727 11.7227 4.97542 11.7227C6.27032 11.7227 7.49707 11.7227 8.79198 11.7227C9.2009 11.7227 9.47351 11.9271 9.67797 12.2679C10.0187 12.8813 9.54166 13.6991 8.86013 13.6991C8.45121 13.5628 8.0423 13.5628 7.63338 13.5628Z" />
                    <path d="M13.6309 8.24643C13.6309 8.45089 13.6309 8.5872 13.6309 8.79166C13.6309 9.20057 13.2902 9.60949 12.8813 9.67764C12.2679 9.81395 11.7227 9.40503 11.7227 8.7235C11.7227 8.38274 11.7227 8.04198 11.7227 7.70121C11.7227 7.15599 12.1997 6.74707 12.6086 6.74707C13.0857 6.74707 13.4946 7.08784 13.6309 7.56491C13.6309 7.63306 13.6309 7.70121 13.6309 7.76936C13.6309 7.90567 13.6309 8.04198 13.6309 8.24643Z" />
                    <path d="M8.79203 17.4473C8.24681 17.4473 7.83789 17.0384 7.83789 16.4932C7.83789 15.948 8.24681 15.5391 8.79203 15.5391C9.33725 15.5391 9.74617 15.948 9.74617 16.4932C9.74617 16.9703 9.33725 17.4473 8.79203 17.4473Z" />
                  </svg>

                  <span className="headermenuname">Scan</span>
                </div>

                <div
                  className="iconhdmin"
                  style={{
                    position: 'relative'
                  }}
                  // onClick={() => {
                  //   dispatch(SearchModal(false));
                  //   dispatch(ProfileSubmenuDropDown(false));
                  // }}
                  onClick={toggleNotifibar}
                >
                  {UnreadNotificationsCount > 0 && <div className="notification_number_circle">{UnreadNotificationsCount}</div>}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Layer_1"
                    data-name="Layer 1"
                    viewBox="0 0 122.88 89.08"
                  >
                    <path d="M70,9.18a29.87,29.87,0,0,1,13.08,8.23A29.38,29.38,0,0,1,90.54,32.2,58.36,58.36,0,0,1,91,43.12c0,2.45-.08,4.89.1,7.22a22.47,22.47,0,0,0,3,10.12A25.4,25.4,0,0,0,102,68.3a4.35,4.35,0,0,1,1.83,2.53,4.47,4.47,0,0,1,0,2.46,4.64,4.64,0,0,1-1.33,2.09,4.43,4.43,0,0,1-2.94,1.09H75.87v0h0a14.56,14.56,0,0,1-28.85,0H23.35a4.4,4.4,0,0,1-3.05-1.19,4.55,4.55,0,0,1-1.25-4.5A4.32,4.32,0,0,1,21,68.22a24.53,24.53,0,0,0,8.39-8.84,25.3,25.3,0,0,0,2.53-12c0-1.57,0-2.46,0-3.37a62.56,62.56,0,0,1,.52-11.85A29.71,29.71,0,0,1,53.1,9.13a8.56,8.56,0,0,1,3.43-3.79,10,10,0,0,1,10,0A8.6,8.6,0,0,1,70,9.18ZM17.71,3.47a2.09,2.09,0,0,1-.62.6A32.49,32.49,0,0,0,13,7.17a28.66,28.66,0,0,0-3.37,3.54,26.28,26.28,0,0,0-2.55,3.92,23.72,23.72,0,0,0-1.7,4.22,22.88,22.88,0,0,0-.84,4.48,24.33,24.33,0,0,0,0,4.67,28.43,28.43,0,0,0,.91,4.83,34,34,0,0,0,1.78,4.88,2.11,2.11,0,0,1,.2.84,2.17,2.17,0,0,1-.14.85,2.25,2.25,0,0,1-.42.7,2.16,2.16,0,0,1-.61.47,1.07,1.07,0,0,1-.22.1,2,2,0,0,1-.79.16,2,2,0,0,1-.81-.14,2.18,2.18,0,0,1-.7-.42,2.42,2.42,0,0,1-.49-.64l-.07-.15a38.61,38.61,0,0,1-2-5.57,32.61,32.61,0,0,1-1-5.54,28.68,28.68,0,0,1,0-5.48,28.17,28.17,0,0,1,1-5.27v0a27.36,27.36,0,0,1,2-5A29.49,29.49,0,0,1,6.11,8,32.57,32.57,0,0,1,10,3.9,36.84,36.84,0,0,1,14.66.37l0,0A2.25,2.25,0,0,1,15.51,0a2.51,2.51,0,0,1,.82,0h0a2.26,2.26,0,0,1,.78.34,2.09,2.09,0,0,1,.6.62h0a2.12,2.12,0,0,1,.31.81,2.26,2.26,0,0,1,0,.86,2.28,2.28,0,0,1-.35.78ZM29.3,13.34l0,0a26.2,26.2,0,0,0-3,2.15,19.35,19.35,0,0,0-2.36,2.34l0,0a15.64,15.64,0,0,0-1.73,2.54A12.89,12.89,0,0,0,21,23.13,13.23,13.23,0,0,0,20.54,26a16,16,0,0,0,.15,3.07,19.18,19.18,0,0,0,.78,3.28v0a24,24,0,0,0,1.43,3.44,2.28,2.28,0,0,1,.22.84,2.06,2.06,0,0,1-.1.82v0a2.22,2.22,0,0,1-.4.72,2.29,2.29,0,0,1-.64.52l-.07,0a2.28,2.28,0,0,1-.83.22,2.13,2.13,0,0,1-.83-.1h0a2.22,2.22,0,0,1-.72-.4,2,2,0,0,1-.52-.64l0-.07a29.85,29.85,0,0,1-1.71-4.15,22.93,22.93,0,0,1-.94-4,19.36,19.36,0,0,1-.16-3.93,17.29,17.29,0,0,1,.64-3.76,17.65,17.65,0,0,1,1.43-3.53,19.37,19.37,0,0,1,2.21-3.27,23.81,23.81,0,0,1,2.92-2.94,31.3,31.3,0,0,1,3.6-2.59l0,0a2.1,2.1,0,0,1,.81-.3,2.07,2.07,0,0,1,.86,0,2.2,2.2,0,0,1,.75.33,2.1,2.1,0,0,1,.57.58l.08.13a2.14,2.14,0,0,1,.28.79A2.27,2.27,0,0,1,30,12.72a2.25,2.25,0,0,1-.58.57l-.07.05Zm76.49-9.27a2.09,2.09,0,0,1-.62-.6,2.28,2.28,0,0,1-.35-.78,2.26,2.26,0,0,1,0-.86,2.12,2.12,0,0,1,.31-.81h0a2.09,2.09,0,0,1,.6-.62,2.26,2.26,0,0,1,.78-.34h0a2.51,2.51,0,0,1,.82,0,2.25,2.25,0,0,1,.81.32l0,0a36.84,36.84,0,0,1,4.67,3.53A32.57,32.57,0,0,1,116.77,8a29.49,29.49,0,0,1,3,4.59,27.36,27.36,0,0,1,2,5v0a28.17,28.17,0,0,1,1,5.27,29.53,29.53,0,0,1,0,5.48,32.61,32.61,0,0,1-1,5.54,38.61,38.61,0,0,1-2,5.57l-.07.15a2.42,2.42,0,0,1-.49.64,2.18,2.18,0,0,1-.7.42,2.21,2.21,0,0,1-1.6,0l-.22-.1a2.16,2.16,0,0,1-.61-.47,2.25,2.25,0,0,1-.42-.7,2.17,2.17,0,0,1-.14-.85,2.11,2.11,0,0,1,.2-.84,34,34,0,0,0,1.78-4.88,28.43,28.43,0,0,0,.91-4.83,24.33,24.33,0,0,0,0-4.67,22.88,22.88,0,0,0-.84-4.48,23.72,23.72,0,0,0-1.7-4.22,25.58,25.58,0,0,0-2.56-3.92,27.84,27.84,0,0,0-3.36-3.54,32.49,32.49,0,0,0-4.11-3.1ZM93.62,13.36l-.11-.07a2.25,2.25,0,0,1-.58-.57,2.27,2.27,0,0,1-.37-1.58,2.14,2.14,0,0,1,.28-.79l.08-.13a2.1,2.1,0,0,1,.57-.58,2.24,2.24,0,0,1,.74-.33,2.24,2.24,0,0,1,1.68.27l0,0a31.3,31.3,0,0,1,3.6,2.59,23.81,23.81,0,0,1,2.92,2.94,19.37,19.37,0,0,1,2.21,3.27,17.65,17.65,0,0,1,1.43,3.53,17.92,17.92,0,0,1,.64,3.76,19.36,19.36,0,0,1-.16,3.93,22.93,22.93,0,0,1-.94,4,29.85,29.85,0,0,1-1.71,4.15l0,.07a2,2,0,0,1-.52.64,2.22,2.22,0,0,1-.72.4h0a2.13,2.13,0,0,1-.83.1,2.28,2.28,0,0,1-.83-.22l-.07,0a2.29,2.29,0,0,1-.64-.52,2.22,2.22,0,0,1-.4-.72v0a2.06,2.06,0,0,1-.1-.82,2.18,2.18,0,0,1,.22-.83,24.55,24.55,0,0,0,1.43-3.45v0a19.18,19.18,0,0,0,.78-3.28,16,16,0,0,0,.15-3.07,13.23,13.23,0,0,0-.49-2.89,12.89,12.89,0,0,0-1.11-2.71A15.64,15.64,0,0,0,99,17.88l0,0a19.35,19.35,0,0,0-2.36-2.34,26.2,26.2,0,0,0-3-2.15Zm-14,7.26a25.15,25.15,0,0,0-12-7.22A2.36,2.36,0,0,1,66,11.77a4,4,0,0,0-1.84-2.38,5.2,5.2,0,0,0-2.6-.68A5,5,0,0,0,59,9.38a4,4,0,0,0-1.8,2.36,2.35,2.35,0,0,1-1.71,1.64A25,25,0,0,0,37,33,59.78,59.78,0,0,0,36.56,44c0,1.44,0,2.85,0,3.44a29.83,29.83,0,0,1-3.07,14.15,28.69,28.69,0,0,1-9.38,10.19H98.73a29.34,29.34,0,0,1-8.64-8.86,27.08,27.08,0,0,1-3.67-12.21c-.19-2.41-.14-5-.1-7.64a54.63,54.63,0,0,0-.43-10,24.7,24.7,0,0,0-6.25-12.39Z" />
                  </svg>
                  <span className="headermenuname">Notification</span>
                </div>

                <div className="iconhdmin g" onClick={sidebaropen}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path d="M 0 9 L 0 11 L 50 11 L 50 9 Z M 0 24 L 0 26 L 50 26 L 50 24 Z M 0 39 L 0 41 L 50 41 L 50 39 Z" />
                  </svg>
                  <span className="headermenuname">Menu</span>
                </div>

                <div className="imgprfls"
                  onClick={handClick}
                >
                  <div className="prflimg">
                    <img
                      // src={
                      //   profilePic?.profilePhoto
                      //     ? profilePic?.profilePhoto
                      //     : "https://st.depositphotos.com/2934765/53192/v/450/depositphotos_531920820-stock-illustration-photo-available-vector-icon-default.jpg"
                      // }
                      src={profilePic?.profilePhoto || searchhomeprofileimg}
                      alt="..."
                      title="Menu"
                    />
                  </div>
                  <div className="iconarrw">
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>

                  {ProfileSubmenuDropDownToggle && (
                    <div className="userDrop">
                      <ul className="userMenu">
                        {
                          (currentPage.includes("businesspage/") || currentPage.includes("OwnContactlist") || currentPage.includes("member/") || currentPage.includes("MemberOtherSavedProfile/") || currentPage.includes("masterdashbord") || currentPage.includes("status") || currentPage.includes("analytics")) &&
                          <li>
                            <Link to={UserProfileID?.memberStatus ? `/profile/${UserProfileID?.userName}` : `/NonMemberuserprofile/${UserProfileID?.personName?.trim()?.replace(/ /g, "_")}`} className="profileLink">
                              <div className="prflimg">
                                <img src={UserProfileID?.profilePhoto || searchhomeprofileimg} alt="img" />
                              </div> <span className="linkText">My profile</span>
                            </Link>
                          </li>
                        }
                        {
                          UserProfileID.businessStatus ? (
                            <>
                              {
                                currentPage.includes("profile/") &&
                                <li>
                                  <Link
                                    // to={`/member/dashboard`} 
                                    to={`/businesspage/${UserProfileID?.companyName.toLowerCase().replace(/\s+/g, "_")}`}
                                    className="profileLink"
                                  >
                                    <div className="prflimg">
                                      <img src={UserProfileID?.businessProfilePic || nophotoCamera} alt="img" />
                                    </div> <span className="linkText">My page</span>
                                  </Link>
                                </li>
                              }

                            </>
                          ) : (
                            <>
                              <li>
                                <Link
                                  // to={`/member/${params}`}
                                  to={`/choosememberplan`}
                                >
                                  <i className="fa-solid fa-gear mr-2"></i>
                                  Create page
                                </Link>
                              </li>
                            </>
                          )
                        }
                        {
                          UserProfileID &&
                          <li>
                            <Link to="/masterdashbord">
                              <i className="fa-solid fa-chart-line mr-2"></i> Master Dashboard
                            </Link>
                          </li>
                        }
                        {
                          UserProfileID && UserProfileID?.memberStatus && (
                            <>

                              <li>
                                <Link>
                                  <i className="fa-solid fa-gear mr-2"></i> Settings
                                </Link>
                              </li>
                            </>
                          )
                        }


                        {partnerStatus && (
                          <li>
                            <Link to="/vender-dashboard">
                              <i className="fa-solid fa-chart-line mr-2"></i>
                              Partner Dashboard
                            </Link>
                          </li>
                        )}

                        {userMemberStatus && (
                          <li>
                            <Link to="/refer-earn-dashboard">
                              <i className="fa-solid fa-people-carry-box mr-2"></i>{" "}
                              Refer and Earn
                            </Link>
                          </li>
                        )}
                        {userMemberStatus && UserProfileID?.memberStatus && (
                          <>
                            <li>
                              {userMemberStatus ? (
                                <Link
                                  to={homePageUrl + paramsUserMember}
                                  onClick={() => dispatch(ShareModalonOff(true))}
                                >
                                  <i className="fa-solid fa-share-nodes mr-2"></i>
                                  Share profile link
                                </Link>
                              ) : (
                                <Link
                                  to={homePageUrl + params}
                                  onClick={() => dispatch(ShareModalonOff(true))}
                                >
                                  <i className="fa-solid fa-share-nodes mr-2"></i>
                                  Share profile link
                                </Link>
                              )}
                            </li>

                            <li>
                              <CopyToClipboard text={userMemberUserLink}>
                                <Link onClick={handleCopyClick}>
                                  <i className="fa-regular fa-paste mr-2"></i>Copy
                                  Profile Link
                                </Link>
                              </CopyToClipboard>
                            </li>
                          </>
                        )}
                        <li>
                          <Link to="/" onClick={handleLogOut}>
                            <i className="fa-solid fa-arrow-right-from-bracket mr-2"></i>
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* {hanndleglass && <TopSearch />} */}
        {SearchBar && <SearchBarmodal />}
        {camera && <QrCamera setCamera={setCamera} />}

        {/****sidebar ***/}
        <Sidebar />

        {/****NotificationBar*****/}
        <NotificationBar show={showNotifibar} closeNotifiBar={toggleNotifibar} />

      </section>
    </>
  );
};

export default Header;
